module.exports = __webpack_public_path__ + "static/media/woodies.dce92e64.png";